import React from "react";
import Header from "../../Layouts/Header";
import "./index.css"; // Import the CSS file
import "../../CommonContainer/common.css"
import teamImage from '../../../Assets/images/aboutimages/team.png'; // Replace with your path
import founderImage from '../../../Assets/images/aboutimages/founder.png'; // Replace with your path
import journeyImage from "../../../Assets/images/aboutimages/journeyImage.png"
import bannerSubimg from "../../../Assets/images/articles-img.png"
import ParticleImage from "../../CommonContainer/ParticleImage";

import Necklace from "../../CommonContainer/Necklace";

import { useNavigate } from "react-router-dom";

const Articles = () => {
       const navigate = useNavigate();
      
          const contactus = () => {
              navigate("/contact-us")
          }
    return (
        <><div>
            <div className="about-hero-section articels-banner">
                <Header />
                <div className="common-width-home-main-container">
                    <div className="about-banner1-main-section">
                        <div>
                            <h1>Divine Silver, Timeless Traditions</h1>
                            <p>Handcrafted 92.5 silver idols and pooja essentials, honoring tradition with timeless elegance.</p>
                            <button className="contact-button" onClick={contactus}  >Contact Us</button>
                        </div>
                        <img src={bannerSubimg} alt="banner1"  data-aos="zoom-in-up"/>
                    </div>
                </div>
            </div>

            <div className="jewellery-carousel-section">
                <Necklace />
            </div>
        </div>
        </>
    );
};

export default Articles;
